export interface RouteTitleConfig {
  title: string;
  subtitle?: string;
}

export const routeTitles: Record<string, RouteTitleConfig> = {
  '/': { title: 'Dashboard' },
  '/dashboard': { title: 'Dashboard' },
  '/agents': { title: 'Agents' },
  '/agent/new': { title: 'Create Agent' },
  '/agent/edit/:id': { title: 'Edit Agent' },
  '/agents/chat/new': { title: 'Chat Agent' },
  '/calls': { title: 'Calls' },
  '/prompts': { title: 'Prompts' },
  '/prompt/create': { title: 'Create Prompt' },
  '/prompt/edit/:id': { title: 'Edit Prompt' },
  '/numbers': { title: 'Numbers' },
  '/dnc-numbers': { title: 'DNC List' },
  '/voices': { title: 'Voices' },
  '/profile': { title: 'Profile' },
  '/providers': { title: 'Providers' },
  '/actions': { title: 'Actions' },
  '/webhooks': { title: 'Webhooks' },
  '/integration-app': { title: 'Integration App' },
  '/campaigns': { title: 'Campaigns' },
  '/beta/campaigns': { title: 'Campaigns (Beta)' },
  '/beta/campaigns/overview/:id': { title: 'Campaign Overview' },
  '/beta/campaigns/new': { title: 'Build Outreach Flow' },
  '/campaigns/create': { title: 'Create Campaign' },
  '/campaigns/edit/:id': { title: 'Edit Campaign' },
  '/campaigns/:id/contacts': { title: 'Campaign Contacts' },
  '/campaigns/:id/contacts/csv': { title: 'Import Contacts from CSV' },
  '/campaigns/:id/contacts/crm': { title: 'Import Contacts from CRM' },
  '/beta/campaigns/business-hours': { title: 'Business Hours' },
  '/change-organization': { title: 'Change Organization' },
  '/billing': { title: 'Billing' },
  '/onboarding': { title: 'Onboarding' },
  '/login': { title: 'Login' },
  '/signup': { title: 'Sign Up' },
  '/reset-password': { title: 'Reset Password' },
  '/settings': { title: 'Settings' },
};
